import React, { HTMLProps, ReactNode, useEffect, useState } from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import './FormSection.scss';
import { Clear } from '@mui/icons-material';

export interface FieldError {
  fieldId: string;
  error: string;
}

type FormSectionProps = HTMLProps<HTMLDivElement> & {
  title: string;
  readOnlyContent?: ReactNode;
  activeContent?: ReactNode;
  initialContent?: ReactNode;
  isActive?: boolean;
  optional?: boolean;
  completed?: boolean;
  initializedByDefault?: boolean;
  onActive: () => void;
  initialIcon?: ReactNode;
  initialText?: string;
  onRemoveSection?: () => void;
  hideEditIcon?: boolean;
};

const FormSection: React.FC<FormSectionProps> = ({
  title,
  readOnlyContent,
  activeContent,
  initialContent,
  isActive,
  optional,
  completed,
  initializedByDefault,
  onActive,
  initialIcon,
  initialText,
  onRemoveSection,
  disabled,
  hideEditIcon,
}) => {
  const [initialized, setInitialized] = useState(initializedByDefault ?? false);
  useEffect(() => {
    setInitialized(initializedByDefault ?? false);
  }, [initializedByDefault]);

  const id = title.replace(/\s+/g, '').toLowerCase();
  return (
    <div
      id={id}
      className={`section ${
        !isActive && !initialized && !disabled && 'initial-state'
      } ${disabled ? 'disabled' : ''}`}
      onClick={() => {
        if (isActive || initialized || disabled) return;
        onActive();
        setInitialized(true);
      }}
    >
      <div
        className={`readonly-header ${disabled ? 'disabled' : ''}`}
        style={{ justifyContent: completed || (!isActive && initialized) ? 'space-between' : 'flex-start' }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isActive && <div className="active-indicator"></div>}
          <span className={`title ${isActive && 'title-active'}`}>{title}</span>
          {optional && <span className="optional">{'(Optional)'}</span>}
          {onRemoveSection && isActive && (
            <div className="remove-icon" onClick={onRemoveSection}>
              Remove
              <Clear className="x-icon" />
            </div>
          )}
        </div>
        {!isActive && initialized && !hideEditIcon && (
          <EditOutlinedIcon onClick={onActive} className="edit-icon" />
        )}
        {completed && (
          <div className="check-icon">
            <CheckRoundedIcon />
          </div>
        )}
      </div>
      <div className={`readonly-body ${disabled ? 'disabled' : ''}`}>
        {isActive ? (
          <div className="active-content">{activeContent}</div>
        ) : initialized ? (
          <div className="read-only-content">{readOnlyContent}</div>
        ) : initialContent ? (
          initialContent
        ) : (
          <div className={`initial-content ${disabled ? 'disabled' : ''}`}>
            <div className="icon-container">{initialIcon}</div>
            <p>{initialText}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormSection;
